export const services = [
  { id: 'svc-graphics', title: 'Graphics', desc: 'Awesome templates for your images.', icon: 'PaintBrushIcon' },
  { id: 'svc-ai', title: 'AI Copywriting', desc: 'Generated marketing text, powered by AI.', icon: 'SparklesIcon' },
  { id: 'svc-scheduling', title: 'Scheduling', desc: 'Plan and automate your social media posts.', icon: 'CalendarDaysIcon' },
  { id: 'svc-analytics', title: 'Analytics', desc: 'Automatic on all social media.', icon: 'ChartBarIcon' },
  { id: 'svc-hashtags', title: 'Hashtags', desc: 'Relevant & trending, freshly updated.', icon: 'HashtagIcon' },
  { id: 'svc-ecommerce', title: 'Ecommerce', desc: 'Announce about new products.', icon: 'ShoppingBagIcon' },
  { id: 'svc-links', title: 'Link Shortener', desc: 'Save space on long links in captions.', icon: 'LinkIcon' },
  { id: 'svc-collab', title: 'Collaboration', desc: 'Create workspaces for members.', icon: 'UsersIcon' },
];

export const CareerPlans = [
  {
    id: 'career-marketing',
    title: 'Marketing-Course',
    price: 'Digital Marketing',
    desc: 'Recorded sessions',
    highlight: false,
    services: [
      'Facebook Ads',
      'Instagram Ads',
      'YouTube Ads',
      'Google Ads',
      'Website Designing',
      'GMB (Google My Business)',
      'DBC (Digital Business Card)',
      'Business Automation',
    ],
  },
  {
    id: 'career-editing',
    title: 'Editing-Course',
    price: 'Editing',
    desc: 'Recorded sessions',
    highlight: true,
    services: [
      'Graphic Design',
      'Business Logo',
      'Flyer Ad Creative',
      'Video Ad Creative',
      'Social Media Creative',
      'Reels Editing',
      'More Services',
    ],
  },
  {
    id: 'career-communication',
    title: 'Communication-Course',
    price: 'Communication Skills',
    desc: 'Recorded sessions',
    highlight: false,
    services: [
      'Script Designing',
      'How to Use Script & Interact with Customers',
      'Talking Off Script',
      'Increase Customer Responses',
      'Objection Handling',
      'Customer Communication Mastery',
      'More Services',
    ],
  },
  {
    id: 'career-nurturing',
    title: 'Nurturing-Course',
    price: 'Nurturing Tools & Training',
    desc: 'Recorded sessions',
    highlight: true,
    services: [
      'WhatsApp Business',
      'Google Sheets',
      'Canva Designing',
      'Script Writing with AI',
      'Business Automation Tools',
      'AI Tools for Business',
      'More Services+',
    ],
  },
];

export const MarketingPlans = [
  {
    id: 'mkt-counseller',
    title: 'Counseller',
    planHeading: 'Counselling Partnership',
    price: '₹10,000 + GST',
    desc: 'Live Training 🔴',
    highlight: false,
    services: [
      'Communication Skills',
      'WhatsApp Business (Mini CRM)',
      'Google Sheets Basic',
      'Live Training',
      'Live Zoom Sessions',
      'Team Support',
      'More Services',
    ],
  },
  {
    id: 'mkt-marketing',
    title: 'Marketing',
    planHeading: 'Digital Marketing Partnership',
    price: '₹12,000 + GST',
    desc: 'Live Training 🔴',
    highlight: true,
    services: [
      'Digital Marketing',
      'Editing',
      'Video Editing',
      'Reels Editing',
      'YouTube Video Editing',
      'Live Zoom Sessions',
      'Team Support',
      'More Services',
    ],
  },
  {
    id: 'mkt-services',
    title: 'Services',
    planHeading: 'All Services Partnership',
    price: '₹15,000 + GST',
    desc: 'Live Training 🔴',
    highlight: false,
    services: [
      'Communication Skills',
      'WhatsApp Business (Mini CRM)',
      'Google Sheets Basic',
      'Digital Marketing',
      'Editing',
      'Team Support',
      'More Services',
    ],
  },
];

export const BusinessPlans = [
  {
    id: 'biz-basic',
    title: 'Basic',
    price: '₹12,000 + GST',
    desc: 'Digital Marketing Essentials',
    highlight: false,
    services: [
      'Google My Business Setup & Optimization',
      'Facebook Ads Management',
      'Instagram Ads Campaign',
      'YouTube Ads Setup',
      'Social Media Page Optimization',
      'Basic SEO Setup',
      'Weekly Performance Reports',
      '24/7 Support',
    ],
  },
  {
    id: 'biz-pro',
    title: 'Pro',
    price: '₹18,000 + GST',
    desc: 'Advanced Digital Solutions',
    highlight: true,
    services: [
      'Professional Website Design',
      '3 Landing Pages',
      'GMB Automation Setup',
      'WhatsApp Business API Integration',
      'CRM System Setup',
      '1 Year Free Hosting',
      'Business Email Setup',
      'Advanced Analytics Dashboard',
      'Priority Support 24/7',
    ],
  },
  {
    id: 'biz-enterprises',
    title: 'Enterprises',
    price: '₹45,000 + GST',
    desc: 'Complete Business Suite',
    highlight: false,
    services: [
      'Custom Coding Website',
      '5 Custom Landing Pages',
      'E-commerce Website',
      'Social Media Management',
      'Shopify Store Setup',
      'WordPress Website',
      'Complete Digital Marketing Suite',
      'Dedicated Project Manager',
      'Priority Support 24/7',
    ],
  },
];

export const coreServices = [
  { id: 'core-web', title: 'Website Development', desc: 'Custom websites built for conversion — fast, mobile-first, and SEO-ready.', icon: 'GlobeAltIcon' },
  { id: 'core-software', title: 'Software Development', desc: 'Scalable business software tailored to your workflows and growth goals.', icon: 'CodeBracketIcon' },
  { id: 'core-app', title: 'App Development', desc: 'iOS and Android apps that deliver seamless user experiences.', icon: 'DevicePhoneMobileIcon' },
  { id: 'core-crm', title: 'CRM Solutions', desc: 'Manage leads, clients, and pipelines with our custom CRM systems.', icon: 'UserGroupIcon' },
  { id: 'core-dm', title: 'Digital Marketing', desc: 'Data-driven campaigns across Google, Facebook, Instagram, and YouTube.', icon: 'MegaphoneIcon' },
  { id: 'core-whatsapp', title: 'WhatsApp Business Cloud API', desc: 'Automate customer engagement at scale with the WhatsApp Cloud API platform.', icon: 'ChatBubbleLeftRightIcon' },
  { id: 'core-leads', title: 'Leads Management Software', desc: 'Capture, track, and convert leads with our intelligent lead management system.', icon: 'FunnelIcon' },
  { id: 'core-support', title: 'Business Support', desc: 'End-to-end business consulting, strategy, and operational growth support.', icon: 'BriefcaseIcon' },
];

export const testimonials = [
  { id: 'test-001', name: 'Rahul Yadav', role: 'Business Owner, Lucknow', text: 'Digital AdBird transformed my business online presence completely. Their digital marketing team is exceptional — we saw a 3x increase in leads within 2 months of working with them.', rating: 5 },
  { id: 'test-002', name: 'Alok Vishwakarma', role: 'Entrepreneur, UP', text: 'The communication skills course was a game-changer. I learned how to pitch my services confidently and close deals. Highly recommend the partnership program.', rating: 5 },
  { id: 'test-003', name: 'Amit Choudry', role: 'Digital Marketer', text: 'I enrolled in the Digital Marketing course and within weeks I was running profitable Facebook and Google ad campaigns. The recorded sessions are very practical and easy to follow.', rating: 5 },
  { id: 'test-004', name: 'KP Yadav', role: 'Small Business Owner', text: 'Their CRM and WhatsApp API setup saved us hours every day. The team is responsive and the support is genuinely 24/7. Best investment for our business.', rating: 5 },
  { id: 'test-005', name: 'Bhagwat Singh Sakhya', role: 'Partner, Lucknow', text: 'Joined the All Services Partnership and the value is incredible. Live Zoom sessions, real training, and a team that actually cares about your growth. Highly recommended.', rating: 5 },
  { id: 'test-006', name: 'Rohit Kumar', role: 'Freelancer, UP', text: 'The editing course helped me build a full freelance career. I now create reels, video ads, and brand creatives for multiple clients. Digital AdBird gave me a real skill.', rating: 5 },
  { id: 'test-007', name: 'Nishant Kumar', role: 'Startup Founder', text: 'From website to social media to ads — Digital AdBird handled everything for our startup launch. Professional, on-time, and results-driven. 10 out of 10.', rating: 5 },
  { id: 'test-008', name: 'Pinki Yadav', role: 'Course Student', text: 'As a homemaker wanting to learn digital skills, the nurturing tools course was perfect. WhatsApp Business, Canva, AI tools — all explained simply. I am now earning from home!', rating: 5 },
];